import { render, staticRenderFns } from "./unset-restrict-register.vue?vue&type=template&id=08cf6bba&scoped=true"
import script from "./unset-restrict-register.vue?vue&type=script&lang=js"
export * from "./unset-restrict-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf6bba",
  null
  
)

export default component.exports